import { render } from "./CategoryMappingTemplate.vue?vue&type=template&id=2072417a&scoped=true&ts=true"
import script from "./CategoryMappingTemplate.vue?vue&type=script&lang=ts"
export * from "./CategoryMappingTemplate.vue?vue&type=script&lang=ts"

import "./CategoryMappingTemplate.vue?vue&type=style&index=0&id=2072417a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2072417a"],['__file',"src/app/catalog/mapping-template/components/CategoryMappingTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2072417a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2072417a', __exports__)) {
    api.reload('2072417a', __exports__)
  }
  
  module.hot.accept("./CategoryMappingTemplate.vue?vue&type=template&id=2072417a&scoped=true&ts=true", () => {
    api.rerender('2072417a', render)
  })

}


export default __exports__